// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f70c6cb4","977":"8c9d02bc"}[chunkId] + ".chunk.js";
};